// libraries
import { Navigate, Location } from "@tanstack/react-location";
import { hasPermission } from "wombat-global/src/utilities/permissions";

// services
import { auth } from "../services/firebase.service";
import { getDecodedAuthToken } from "../contexts/authentication/getDecodedAuthToken";
import {
  getLocalStorageItem,
  LOCATION_RESTORE_KEY,
} from "../hooks/useLocalStorage";
import { getPriorityTarget } from "../contexts/authentication/getPriorityLoginTarget";
import { isAllowedCachedPath } from "./file-routing";
import { getTargetLandingPath } from "../utilities/target-landing-path";

export default function routeElement(): () => Promise<JSX.Element> {
  return async function innerAsyncFunction(): Promise<JSX.Element> {
    // oxlint-disable-next-line no-console
    console.time("auth-loading");
    await auth.authStateReady();
    // oxlint-disable-next-line no-console
    console.timeEnd("auth-loading");

    const token = await getDecodedAuthToken();
    const claims = token?.claims;

    if (!token || !claims) {
      return <Navigate to="/login" />;
    }

    const target = await getPriorityTarget(claims);
    if (!target) {
      return <Navigate to="/no-access" />;
    }

    /**
     * When mobile app is closed and then reopened it navigates to "/" we want to
     * restore the previous path when the auth state is still valid.
     */
    const locationRestore = getLocalStorageItem<Location>(LOCATION_RESTORE_KEY);
    if (locationRestore && isAllowedCachedPath(locationRestore?.pathname)) {
      return (
        <Navigate to={locationRestore.pathname + locationRestore.searchStr} />
      );
    }

    return (
      <Navigate
        to={getTargetLandingPath(target, (_target, permissionFlag) =>
          hasPermission(_target, claims, permissionFlag),
        )}
      />
    );
  };
}
